import { getEmissionsFaktor } from '../../../../main/functions/getEmmissionsFaktor';
import { getTrimmedMean } from './getTrimmedMean';
import { getUmrechungsFaktor } from '../../../../main/functions/getUmrechnungsFaktor';
import { getValueCluster } from './getValueCluster';
import { IDs } from '../../../../helpers/IDs';

export function processAggregation(data: any, modi?: number[], zeitraeume?: number[]): any[] {
    const agg = data[IDs.ENT_KENNZAHLEN_WERTE_AGGREGATION] || [];
    const def = data[IDs.ENT_KENNZAHLEN_DEFINTION] || [];
    const roh = data[IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL] || [];
    const value_clusters = getValueCluster();
    console.log('KENN DEF:', def);
    let baseMap: any = {};
    let list: any[] = [];
    let tempMap: any = {};
    preprocessRoh(data);
    const process = (modus?: number, zeitraum?: number): any => {
        tempMap = {};
        // 1. Schleife aufsummieren und zählen
        roh.filter((r: any) => r.kuerzel === 'umsatz' || true).forEach((r: any, idx: number) => {
            // const jahr: number = +r.jahr || 0;
            if (idx < 20) {
                // console.log('Roh', r);
            }
            const branchen_gewerke_tid = r.branchen_gewerke_tid_orig;
            const betriebliche_situation = r.betriebliche_situation;
            const kuerzel = r.kuerzel;
            const is_gewerk = def.find((d: any) => d.kuerzel === kuerzel && d.is_gewerk === 1);
            if (is_gewerk) {
                console.log('IG', kuerzel);
            }
            const key_gw_alle = `ALLE_${branchen_gewerke_tid}_${kuerzel}`;
            const key_bs_alle = `ALLE_${betriebliche_situation}_${kuerzel}`;
            const key_hw_alle = `ALLE_Handwerk_gesamt_${kuerzel}`;
            // const key_gw_jahr = `${jahr}_${branchen_gewerke_tid}_${kuerzel}`;
            // const key_bs_jahr = `${jahr}_${betriebliche_situation}_${kuerzel}`;
            // const key_hw_jahr = `${jahr}_Handwerk_gesamt_${kuerzel}`;
            let value_cluster = value_clusters.default;
            if (value_clusters[branchen_gewerke_tid + '']) {
                value_cluster = value_clusters[branchen_gewerke_tid + ''];
            }
            // if (kuerzel === 'energiekosten_umsatz') {
            //     console.log('ITEM (R)', r);
            // }
            if (r.um_cluster) {
                addToTmpMap(tempMap, `${key_gw_alle}_um_${r.um_cluster}`, kuerzel, r, 0, branchen_gewerke_tid, null, 'umsatz', r.um_cluster, modus, zeitraum, baseMap);
                // addToTmpMap(tempMap, `${key_gw_jahr}_um_${r.um_cluster}`, kuerzel, r, jahr, branchen_gewerke_tid, null, 'umsatz', r.um_cluster, modus, zeitraum, baseMap);
                if (!is_gewerk && branchen_gewerke_tid !== 148) {
                    addToTmpMap(tempMap, `${key_bs_alle}_um_${r.um_cluster}`, kuerzel, r, 0, -1, betriebliche_situation, 'umsatz', r.um_cluster, modus, zeitraum, baseMap);
                    addToTmpMap(tempMap, `${key_hw_alle}_um_${r.um_cluster}`, kuerzel, r, 0, -2, 'handwerk_gesamt', 'umsatz', r.um_cluster, modus, zeitraum, baseMap);
                    // addToTmpMap(tempMap, `${key_bs_jahr}_um_${r.um_cluster}`, kuerzel, r, jahr, -1, betriebliche_situation, 'umsatz', r.um_cluster, modus, zeitraum, baseMap);
                    // addToTmpMap(tempMap, `${key_hw_jahr}_um_${r.um_cluster}`, kuerzel, r, jahr, -2, 'handwerk_gesamt', 'umsatz', r.um_cluster, modus, zeitraum, baseMap);
                }
            }
            if (r.ma_cluster) {
                addToTmpMap(tempMap, `${key_gw_alle}_ma_${r.ma_cluster}`, kuerzel, r, 0, branchen_gewerke_tid, null, 'mitarbeiter', r.ma_cluster, modus, zeitraum, baseMap);
                // addToTmpMap(tempMap, `${key_gw_jahr}_ma_${r.ma_cluster}`, kuerzel, r, jahr, branchen_gewerke_tid, null, 'mitarbeiter', r.ma_cluster, modus, zeitraum, baseMap);
                if (!is_gewerk && branchen_gewerke_tid !== 148) {
                    addToTmpMap(tempMap, `${key_bs_alle}_ma_${r.ma_cluster}`, kuerzel, r, 0, -1, betriebliche_situation, 'mitarbeiter', r.ma_cluster, modus, zeitraum, baseMap);
                    addToTmpMap(tempMap, `${key_hw_alle}_ma_${r.ma_cluster}`, kuerzel, r, 0, -2, 'handwerk_gesamt', 'mitarbeiter', r.ma_cluster, modus, zeitraum, baseMap);
                    // addToTmpMap(tempMap, `${key_bs_jahr}_ma_${r.ma_cluster}`, kuerzel, r, jahr, -1, betriebliche_situation, 'mitarbeiter', r.ma_cluster, modus, zeitraum, baseMap);
                    // addToTmpMap(tempMap, `${key_hw_jahr}_ma_${r.ma_cluster}`, kuerzel, r, jahr, -2, 'handwerk_gesamt', 'mitarbeiter', r.ma_cluster, modus, zeitraum, baseMap);
                }
            }
            if (value_cluster.xt1_key && r.xt1_cluster) {
                addToTmpMap(tempMap, `${key_gw_alle}_xt1_${r.xt1_cluster}`, kuerzel, r, 0, branchen_gewerke_tid, null, 'extra1', r.xt1_cluster, modus, zeitraum, baseMap);
                // addToTmpMap(tempMap, `${key_gw_jahr}_xt1_${r.xt1_cluster}`, kuerzel, r, jahr, branchen_gewerke_tid, null, 'extra1', r.xt1_cluster, modus, zeitraum, baseMap);
                /* if (!is_gewerk && branchen_gewerke_tid !== 148) {
                    addToTmpMap(tempMap, `${key_bs_alle}_xt1_${r.xt1_cluster}`, kuerzel, r, 0, -1, betriebliche_situation, 'extra1', r.xt1_cluster, modus, zeitraum, baseMap);
                    addToTmpMap(tempMap, `${key_hw_alle}_xt1_${r.xt1_cluster}`, kuerzel, r, 0, -2, 'handwerk_gesamt', 'extra1', r.xt1_cluster, modus, zeitraum, baseMap);
                } */
            }
            if (value_cluster.xt2_key && r.xt2_cluster) {
                addToTmpMap(tempMap, `${key_gw_alle}_xt2_${r.xt2_cluster}`, kuerzel, r, 0, branchen_gewerke_tid, null, 'extra2', r.xt2_cluster, modus, zeitraum, baseMap);
                // addToTmpMap(tempMap, `${key_gw_jahr}_xt2_${r.xt2_cluster}`, kuerzel, r, jahr, branchen_gewerke_tid, null, 'extra2', r.xt2_cluster, modus, zeitraum, baseMap);
                /* if (!is_gewerk && branchen_gewerke_tid !== 148) {
                    addToTmpMap(tempMap, `${key_bs_alle}_xt2_${r.xt2_cluster}`, kuerzel, r, 0, -1, betriebliche_situation, 'extra2', r.xt2_cluster, modus, zeitraum, baseMap);
                    addToTmpMap(tempMap, `${key_hw_alle}_xt2_${r.xt2_cluster}`, kuerzel, r, 0, -2, 'handwerk_gesamt', 'extra2', r.xt2_cluster, modus, zeitraum, baseMap);
                } */
            }
            // ma_cluster, um_cluster, xt1_cluster, xt2_cluster
            addToTmpMap(tempMap, key_gw_alle, kuerzel, r, 0, branchen_gewerke_tid, null, null, null, modus, zeitraum, baseMap);
            // addToTmpMap(tempMap, key_gw_jahr, kuerzel, r, jahr, branchen_gewerke_tid, null, null, null, modus, zeitraum, baseMap);
            if (!is_gewerk && branchen_gewerke_tid !== 148) {
                addToTmpMap(tempMap, key_bs_alle, kuerzel, r, 0, -1, betriebliche_situation, null, null, modus, zeitraum, baseMap);
                addToTmpMap(tempMap, key_hw_alle, kuerzel, r, 0, -2, 'handwerk_gesamt', null, null, modus, zeitraum, baseMap);
                // addToTmpMap(tempMap, key_bs_jahr, kuerzel, r, jahr, -1, betriebliche_situation, null, null, modus, zeitraum, baseMap);
                // addToTmpMap(tempMap, key_hw_jahr, kuerzel, r, jahr, -2, 'handwerk_gesamt', null, null, modus, zeitraum, baseMap);
            }
        });
        if (!modus && !zeitraum) {
            baseMap = tempMap;
        }
        // 2. Schleife Datensätze erzeugen ...
        // console.log('TMP', tempMap);
        console.log('AGG', agg);
        let cnt_total = 0;
        let cnt_found = 0;
        const saveList = Object.keys(tempMap).map((key: string) => {
            const item = tempMap[key];
            const modus: number = +item.modus || 100;
            const prozent: number = modus < 100 ? ((100 - modus) / 100) / 2 : 0;
            const werte: number[] = item.werte || [];
            item.wert_avg = item.wert / item.anzahl; // Aus der Summe den Durchschnitt machen
            item.wert_min = item.min;
            item.wert_max = item.max;
            // if (item.kuerzel === 'energiekosten_umsatz') {
            //     console.log('ITEM (S)', item);
            // }
            // console.log('S', item);
            getTrimmedMean(werte, prozent, (data: any) => {
                item.anzahl = (data.values || []).length;
                item.wert_avg = data.avg;
                item.wert_min = data.min;
                item.wert_max = data.max;
                delete item.werte;
            });
            const foundOld = agg.find((ad: any) =>
                ad.kuerzel === item.kuerzel && (
                    (ad.branchen_gewerke_tid_orig > 0 && ad.branchen_gewerke_tid_orig === item.branchen_gewerke_tid)
                    || (ad.branchen_gewerke_tid === -1 && item.branchen_gewerke_tid === -1 && ad.betriebliche_situation === item.betriebliche_situation)
                    || (ad.branchen_gewerke_tid === -2 && item.branchen_gewerke_tid === -2 && ad.betriebliche_situation === item.betriebliche_situation)
                    // || (ad.branchen_gewerke_tid === -1 && ad.betriebliche_situation === item.betriebliche_situation)
                    // || (ad.branchen_gewerke_tid === -2 && item.branchen_gewerke_tid === -2)
                )
                && ad.jahr === item.jahr
                && (ad.modus || 100) === (item.modus || 100)
                && (ad.zeitraum || null) === (item.zeitraum || null)
                && (ad.cluster_name === item.cluster_name || (!ad.cluster_name && !item.cluster_name))
                && (ad.cluster_id === item.cluster_id || (!ad.cluster_id && !item.cluster_id))
            );
            item.tid = foundOld ? foundOld.tid : 0;
            if (item.tid === 0) {
                // console.log('NOT FOUND: ', item);
            } else {
                cnt_found++;
            }
            cnt_total++;
            return item;
        });
        console.log(`CNT: ${cnt_found} -> ${cnt_total}`);
        return saveList;
    };
    modi = [null, ...modi];
    zeitraeume = [null, ...zeitraeume];

    (modi || []).forEach((modus: number) =>
        (zeitraeume || []).forEach((zeitraum: number) =>
            list = [...list, ...(process(modus, zeitraum) || [])]
        )
    );
    return list;
}

function addToTmpMap(
    tempMap: any, key: string, kuerzel: string, r: any, jahr: number, branchen_gewerke_tid: number, betriebliche_situation: string,
    cluster_name: string, cluster_id: number, modus: number, zeitraum: number, baseMap: any
): void {
    // if (!isInRangeModus(r.wert, key, modus, baseMap)) {
    //     return;
    // }
    if (!isInRangeJahr(r.jahr, zeitraum)) {
        return;
    }
    if (!cluster_id) {
        cluster_id = 0;
    }
    if (!tempMap[key]) {
        // if (kuerzel === 'energiekosten_umsatz') {
        //     console.log('ITEM (A)', key , r);
        // }
        tempMap[key] = {
            anzahl: 0, wert: 0, kuerzel, jahr: typeof zeitraum === 'number' ? new Date().getFullYear() - 1 : jahr, branchen_gewerke_tid,
            betriebliche_situation, cluster_name, cluster_id, modus: modus || 100, zeitraum: zeitraum || null
        };
    }
    if (typeof tempMap[key].werte === 'undefined') {
        tempMap[key].werte = [];
    }
    tempMap[key].werte.push(r.wert);
    tempMap[key].anzahl++;
    tempMap[key].wert += r.wert;

    if (!tempMap[key].min || +tempMap[key].min > +r.wert) {
        tempMap[key].min = r.wert;
    }
    if (!tempMap[key].max || +tempMap[key].max < +r.wert) {
        tempMap[key].max = r.wert;
    }
}

function isInRangeJahr(value: number, zeitraum: number): boolean {
    if (!zeitraum) {
        return true;
    } else if (typeof value !== 'number') {
        return false;
    }
    const max: number = new Date().getFullYear() - 1;
    const min: number = max - zeitraum;

    return value >= min && value <= max;
}

function isInRangeModus(value: number, key: string, modus: number, data: any): boolean {
    const item: any = (data || {})[key] || {};

    if (!modus) {
        return true;
    } else if (typeof value !== 'number' || typeof item.wert_max !== 'number' || typeof item.wert_max !== 'number') {
        return false;
    }
    const range: number = item.wert_max - item.wert_min;
    const gap: number = (range - ((modus / 100) * range)) / 2;
    const max: number = item.wert_max - gap;
    const min: number = item.wert_min + gap;

    return value >= min && value <= max;
}

function preprocessRoh(data: any): void {
   const roh = data[IDs.ENT_KENNZAHLEN_WERTE_ZENTRAL] || [];
   const value_clusters = getValueCluster();
   // console.log('Roh', roh);
   const map: any = {};
   roh.forEach((r: any) => {
        const betrieb = r.betrieb;
        const jahr = r.jahr;
        const kuerzel = r.kuerzel;
        const wert = r.wert;
        const branche = r.​​branchen_gewerke_tid_orig;
        const betriebliche_situation = r.betriebliche_situation;
        // console.log(jahr, betrieb, kuerzel, wert, branche);
        // FÜR GEWERK
        if (map[branche] === undefined) { map[branche] = {}; }
        if (map[branche][betrieb] === undefined) { map[branche][betrieb] = {}; }
        if (map[branche][betrieb][jahr] === undefined) { map[branche][betrieb][jahr] = {}; }
        map[branche][betrieb][jahr][kuerzel] = wert;
        map[branche][betrieb][jahr]['betriebliche_situation'] = betriebliche_situation;
   });
   Object.keys(map).forEach((gewerk: any) => {
        let value_cluster = value_clusters.default;
        if (value_clusters[gewerk + '']) {
            value_cluster = value_clusters[gewerk + ''];
        }
        const betriebe = map[gewerk];
        Object.keys(betriebe).forEach((betrieb: any) => {
            const jahre = betriebe[betrieb];
            Object.keys(jahre).forEach((jahr: any) => {
                const werte = jahre[jahr];
                // Faktoren Heizwerte
                const faktor_gas_m3 = getUmrechungsFaktor(data, '', jahr, 'erdgas_m3');
                const faktor_oel_verbrauch_l = getUmrechungsFaktor(data, '', jahr, 'heizoel_leicht');
                const faktor_diesel_verbrauch = getUmrechungsFaktor(data, '', jahr, 'dieselkraftstoffe');
                const faktor_benzin_verbrauch = getUmrechungsFaktor(data, '', jahr, 'ottokraftstoffe');
                // Faktoren Emission
                const faktor_diesel_co2 = getEmissionsFaktor(data, '', jahr, 'diesel');
                const faktor_benzin_co2 = getEmissionsFaktor(data, '', jahr, 'ottokraftstoff');
                const faktor_erdgas_co2 = getEmissionsFaktor(data, '', jahr, 'erdgas');
                const faktor_oel_co2 = getEmissionsFaktor(data, '', jahr, 'heizoel_leicht');
                const faktor_strom_co2 = getEmissionsFaktor(data, '', jahr, 'strom_mix');
                const faktor_fw_co2 = getEmissionsFaktor(data, '', jahr, 'fernwaerme_mix');

                const gas_verbrauch_m3 = werte.gas_verbrauch_m3 || 0;
                const gas_verbrauch_kwh = werte.gas_verbrauch_kwh || 0;
                const strom_verbrauch_gesamt = werte.strom_verbrauch_gesamt || 0;
                const fw_verbrauch = werte.fw_verbrauch || 0;
                const oel_verbrauch_l = werte.oel_verbrauch_l || 0;
                const oel_verbrauch_kwh = werte.oel_verbrauch_kwh || 0;
                const diesel_verbrauch = werte.diesel_verbrauch || 0;
                const benzin_verbrauch = werte.benzin_verbrauch || 0;

                const betriebliche_situation = werte.betriebliche_situation;

                const strom_kosten_gesamt = werte.strom_kosten_gesamt || 0;
                const oel_kosten = werte.oel_kosten || 0;
                const gas_kosten = werte.gas_kosten || 0;
                const kraftstoffe_kosten = werte.kraftstoffe_kosten || 0;

                const kosten_total = strom_kosten_gesamt + oel_kosten + gas_kosten + kraftstoffe_kosten;

                const mitarbeiter = werte.mitarbeiter;
                const umsatz = werte.umsatz;

                const eigenstrom_verbrauch = werte.eigenstrom_verbrauch;

                const back_flaeche = werte.back_flaeche;
                const mehl_verbrauch = werte.mehl_verbrauch;
                const flaeche = werte.flaeche;
                const prod_flaeche = werte.prod_flaeche;
                const fleisch_verbrauch = werte.fleisch_verbrauch;
                const waerme_kwh = oel_verbrauch_kwh +
                    oel_verbrauch_l * faktor_oel_verbrauch_l +
                    gas_verbrauch_kwh +
                    gas_verbrauch_m3 * faktor_gas_m3 +
                    fw_verbrauch;
                const kraftstoff_kwh = (benzin_verbrauch * faktor_benzin_verbrauch) + (diesel_verbrauch * faktor_diesel_verbrauch);
                // CLUSTER BESTIMMEN
                let ma_cluster = undefined;
                let um_cluster = undefined;
                let xt1_cluster = undefined;
                let xt2_cluster = undefined;
                if (mitarbeiter) { ma_cluster = 1; }
                if (mitarbeiter >= value_cluster.ma_val1) { ma_cluster = 2; }
                if (mitarbeiter >= value_cluster.ma_val2) { ma_cluster = 3; }
                if (umsatz) { um_cluster = 1; }
                if (umsatz >= value_cluster.um_val1) { um_cluster = 2; }
                if (umsatz >= value_cluster.um_val2) { um_cluster = 3; }
                if (value_cluster.xt1_key) {
                    if (werte[value_cluster.xt1_key]) { xt1_cluster = 1; }
                    if (werte[value_cluster.xt1_key] >= value_cluster.xt1_val1) { xt1_cluster = 2; }
                    if (werte[value_cluster.xt1_key] >= value_cluster.xt1_val2) { xt1_cluster = 3; }
                }
                if (value_cluster.xt2_key) {
                    if (werte[value_cluster.xt2_key]) { xt2_cluster = 1; }
                    if (werte[value_cluster.xt2_key] >= value_cluster.xt2_val1) { xt2_cluster = 2; }
                    if (werte[value_cluster.xt2_key] >= value_cluster.xt2_val2) { xt2_cluster = 3; }
                }
                const gesamtverbrauch = waerme_kwh + kraftstoff_kwh + strom_verbrauch_gesamt;
                const base: any = {
                    ​​branchen_gewerke_tid_orig: +gewerk, betrieb, jahr: +jahr, betriebliche_situation, ma_cluster, um_cluster,
                    xt1_cluster, xt2_cluster
                };
                if (!werte['diesel_kwh'] && diesel_verbrauch) {
                    const wert_calc = diesel_verbrauch * faktor_diesel_verbrauch;
                    const row = { ...base, kuerzel: 'diesel_kwh', wert: wert_calc };
                    roh.push(row);
                }
                if (!werte['benzin_kwh'] && benzin_verbrauch) {
                    const wert_calc = benzin_verbrauch * faktor_benzin_verbrauch;
                    const row = { ...base, kuerzel: 'benzin_kwh', wert: wert_calc };
                    roh.push(row);
                }
                if (!werte['kraftstoff_kwh']) {
                    const wert_calc = (benzin_verbrauch || 0) * faktor_benzin_verbrauch + (diesel_verbrauch || 0) * faktor_diesel_verbrauch;
                    if (wert_calc > 0) {
                        const row = { ...base, kuerzel: 'kraftstoff_kwh', wert: wert_calc };
                        roh.push(row);
                    }
                }
                // const row = { ...base, kuerzel: 'waerme_ma', wert: wert_calc };


                // console.log('BASE', base);
                const co2_emission = (
                    oel_verbrauch_kwh * faktor_oel_co2 +
                    oel_verbrauch_l * faktor_oel_verbrauch_l * faktor_oel_co2 +
                    gas_verbrauch_kwh * faktor_erdgas_co2 +
                    gas_verbrauch_m3 * faktor_gas_m3 * faktor_erdgas_co2 +
                    benzin_verbrauch * faktor_benzin_verbrauch * faktor_benzin_co2 +
                    diesel_verbrauch * faktor_diesel_verbrauch * faktor_diesel_co2 +
                    strom_verbrauch_gesamt * faktor_strom_co2 +
                    fw_verbrauch * faktor_fw_co2
                );
                if (eigenstrom_verbrauch && eigenstrom_verbrauch > 0 && strom_verbrauch_gesamt && strom_verbrauch_gesamt > 0) {
                    const eigenstrom_anteil = eigenstrom_verbrauch / (strom_verbrauch_gesamt + eigenstrom_verbrauch);
                    const row = { ...base, kuerzel: 'eigenstrom_anteil', wert: eigenstrom_anteil };
                    roh.push(row);
                }
                if (co2_emission > 0 && typeof werte.co2_emission === 'undefined') {
                    const row = { ...base, kuerzel: 'co2_emission', wert: co2_emission };
                    roh.push(row);
                }
                if (mitarbeiter > 0 && co2_emission > 0) {
                    const wert_calc = Math.round((co2_emission / mitarbeiter) * 100) / 100;
                    const row = { ...base, kuerzel: 'co2_mitarbeiter', wert: wert_calc };
                    roh.push(row);
                }
                if (mitarbeiter > 0 && waerme_kwh > 0) {
                    const wert_calc = Math.round((waerme_kwh / mitarbeiter) * 100) / 100;
                    const row = { ...base, kuerzel: 'waerme_ma', wert: wert_calc };
                    roh.push(row);
                }
                if (mitarbeiter > 0 && strom_verbrauch_gesamt > 0) {
                    const wert_calc = Math.round((strom_verbrauch_gesamt / mitarbeiter) * 100) / 100;
                    const row = { ...base, kuerzel: 'strom_ma', wert: wert_calc };
                    roh.push(row);
                }
                if (mitarbeiter > 0 && gesamtverbrauch > 0) {
                    const wert_calc = Math.round((gesamtverbrauch / mitarbeiter) * 100) / 100;
                    const row = { ...base, kuerzel: 'energieverbrauch_ma', wert: wert_calc };
                    roh.push(row);
                }
                if (umsatz > 0 && gesamtverbrauch > 0) {
                    const wert_calc = Math.round((gesamtverbrauch / umsatz) * 100) / 100;
                    const row = { ...base, kuerzel: 'energieverbrauch_umsatz', wert: wert_calc };
                    roh.push(row);
                }
                if (kosten_total > 0 && umsatz > 0) {
                    const wert_calc = Math.round((kosten_total / umsatz) * 100 * 100) / 100;
                    const row = { ...base, kuerzel: 'energiekosten_umsatz', wert: wert_calc };
                    roh.push(row);
                }
                if (kosten_total > 0 && mitarbeiter > 0) {
                    const wert_calc = Math.round((kosten_total / mitarbeiter) * 100) / 100;
                    if (wert_calc < 0) { console.log('ERR KMA', kosten_total, mitarbeiter, wert_calc); }
                    const row = { ...base, kuerzel: 'energiekosten_ma', wert: wert_calc };
                    roh.push(row);
                }
                if (mehl_verbrauch > 0 && gesamtverbrauch > 0) {
                    const wert_calc = Math.round((gesamtverbrauch / mehl_verbrauch) * 100) / 100;
                    const row = { ...base, kuerzel: 'energie_mehl', wert: wert_calc };
                    roh.push(row);
                }
                if (back_flaeche > 0 && gesamtverbrauch > 0) {
                    const wert_calc = Math.round((gesamtverbrauch / back_flaeche) * 100) / 100;
                    const row = { ...base, kuerzel: 'energie_back_flaeche', wert: wert_calc };
                    roh.push(row);
                }
                if (fleisch_verbrauch > 0 && gesamtverbrauch > 0) {
                    const wert_calc = Math.round((gesamtverbrauch / fleisch_verbrauch) * 100) / 100;
                    const row = { ...base, kuerzel: 'energie_fleisch_verbrauch', wert: wert_calc };
                    roh.push(row);
                }
                if (prod_flaeche > 0 && gesamtverbrauch > 0) {
                    const wert_calc = Math.round((gesamtverbrauch / prod_flaeche) * 100) / 100;
                    const row = { ...base, kuerzel: 'energie_prod_flaeche', wert: wert_calc };
                    roh.push(row);
                }
                if (flaeche > 0 && gesamtverbrauch > 0) {
                    const wert_calc = Math.round((gesamtverbrauch / flaeche) * 100) / 100;
                    const row = { ...base, kuerzel: 'energie_gebaeude_flaeche', wert: wert_calc };
                    roh.push(row);
                }
                // const energiekosten_umsatz = Math.round((kosten_total / umsatz) * 100 * 100) / 100;
                // const energieverbrauch_ma = Math.round((gesamtverbrauch / mitarbeiter) * 100 * 100) / 100;
                // const energiekosten_ma = Math.round((kosten_total / mitarbeiter) * 100 * 100) / 100;
                // const energie_back_flaeche = back_flaeche ? Math.round((gesamtverbrauch / back_flaeche) * 100 * 100) / 100 : 0;
                // const energie_mehl = mehl_verbrauch ? Math.round((gesamtverbrauch / mehl_verbrauch) * 100 * 100) / 100 : 0;
            });
        });
   });
}
